import React from "react"
import { Box, Heading } from '@chakra-ui/react'
import Layout from '../layout'
import { getConfig } from "../reducers"
import { useSelector } from "react-redux"


const Terminos_condiciones = () => {

    const config = useSelector(state => getConfig(state))

    return (
        <Layout>


            <Box w={"full"} p={4} m={"auto"} mt={"3.5rem"} mb={"2rem"} maxW={"1400px"} textAlign={"justify"}>
                <Heading>Terminos y condiciones</Heading>
                <br />
                 <div className="blogContent" dangerouslySetInnerHTML={{ __html: config.terms }} />
            </Box>

        </Layout >
    )
}

export default Terminos_condiciones